/* @flow strict */

import available from './DOM_available';

type TransformType = (any) => any;

const _transform: TransformType = (data) => data;

const window = available<{} | false>('window', false);

const extractScriptData = (key: string, transform: TransformType = _transform): any => {
  if (!window) {
    return null;
  }

  const data = window[key];
  const script = window.document.getElementById(key);

  if (script) {
    script.parentNode.removeChild(script);
  }

  delete window[key];

  return transform(data);
};

export default extractScriptData;
